export const formatNumber = (value: number, decimals?: number): string => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits:
      decimals !== undefined ? decimals : value % 1 === 0 ? 0 : 2,
    maximumFractionDigits:
      decimals !== undefined ? decimals : value % 1 === 0 ? 0 : 2,
  }).format(value);
};
